/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumncredits3Inputs */

const en_aicostscolumncredits3 = /** @type {(inputs: Aicostscolumncredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const de_aicostscolumncredits3 = /** @type {(inputs: Aicostscolumncredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Aicostscolumncredits3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumncredits3 = /** @type {((inputs?: Aicostscolumncredits3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumncredits3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumncredits3(inputs)
	return de_aicostscolumncredits3(inputs)
});
export { aicostscolumncredits3 as "aiCostsColumnCredits" }